export const ALL_ADMIN_AUDIT_TRAIL = "ALL_ADMIN_AUDIT_TRAIL";
export const ALL_ADMIN_AUDIT_TRAIL_FAIL = "ALL_ADMIN_AUDIT_TRAIL_FAIL";
export const ALL_ADMIN_AUDIT_TRAIL_STATUS = "ALL_ADMIN_AUDIT_TRAIL_STATUS";
